import { IHasId } from "#@/collections/interfaces/hasId";
import { Id } from "#@/collections/typeId";
//import { IJobReqResData } from "#@/taskRunner/data/jobReqRes";

export class JobData implements IHasId {
    id: Id=null;
    taskName: string | undefined;
    requestData?: object | undefined;
    responseData?: object | undefined;
}